import { render, staticRenderFns } from "./SlugCheck.vue?vue&type=template&id=e254e2e2"
import script from "./SlugCheck.vue?vue&type=script&lang=js"
export * from "./SlugCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports